import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../reduxStore";
import { hideLoader, showLoader } from "./loaderSlice";
import { showErrorSnackbar } from "./snackbarSlice";
import { getSupplierDetails } from "../../ApiServices/SupplierServices";
import { t } from "i18next";

export const initialState = {
	value: null,
	loading: false,
	error: null,
};

const supplierSlice = createSlice({
	name: "supplier",
	initialState: initialState,
	reducers: {
		clearSupplierState(state: any) {
			state.value = initialState.value;
			state.loading = false;
			state.error = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(
			fetchSupplierDetails.fulfilled,
			(state: any, action: any) => {
				state.error = initialState.error;
				state.loading = initialState.loading;
				state.value = action?.payload?.data;
			}
		);
		builder.addCase(
			fetchSupplierDetails.rejected,
			(state: any, action: any) => {
				state.error = action?.payload?.error?.message;
				state.loading = initialState.loading;
				state.value = initialState?.value;
			}
		);
	},
});

export const supplierState = (state: RootState) => state?.supplier;
export const { clearSupplierState } = supplierSlice.actions;
export default supplierSlice.reducer;

export const fetchSupplierDetails = createAsyncThunk(
	"supplier/fetchSupplierDetails",
	async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
		try {
			dispatch(showLoader({ message:t('FETCHING_SUPPLIER_DETAILS') }));
			return fulfillWithValue(await getSupplierDetails());
		} catch (error: any) {
			dispatch(showErrorSnackbar({ message: error }));
			return rejectWithValue(error);
		} finally {
			dispatch(hideLoader());
		}
	}
);
